import * as React from 'react';

export default function Exit({props}) {
  return (
    <svg xmlns="http://www.w3.org/2000/svg" width={53.216} height={53.216} {...props}>
      <defs>
        <filter id="a" x={0} y={0} width={53.216} height={53.216} filterUnits="userSpaceOnUse">
          <feOffset />
          <feGaussianBlur stdDeviation={3} result="blur" />
          <feFlood floodColor="#f5ff00" floodOpacity={0.616} />
          <feComposite operator="in" in2="blur" />
          <feComposite in="SourceGraphic" />
        </filter>
        <filter
          id="b"
          x={9.922}
          y={13.659}
          width={33.373}
          height={33.373}
          filterUnits="userSpaceOnUse"
        >
          <feOffset dy={3} />
          <feGaussianBlur stdDeviation={3} result="blur-2" />
          <feFlood floodColor="#f5ff00" floodOpacity={0.482} />
          <feComposite operator="in" in2="blur-2" />
          <feComposite in="SourceGraphic" />
        </filter>
      </defs>
      <g filter="url(#a)">
        <g data-name="Path 4058" fill="none">
          <path d="M26.608 9A17.608 17.608 0 1 1 9 26.608 17.608 17.608 0 0 1 26.608 9Z" />
          <path
            d="M26.608 11c-4.169 0-8.088 1.624-11.036 4.571A15.506 15.506 0 0 0 11 26.608c0 4.169 1.624 8.089 4.572 11.036a15.506 15.506 0 0 0 11.036 4.572c4.17 0 8.089-1.624 11.037-4.572a15.506 15.506 0 0 0 4.571-11.036c0-4.17-1.623-8.089-4.571-11.037A15.506 15.506 0 0 0 26.608 11m0-2c9.725 0 17.608 7.883 17.608 17.608 0 9.725-7.883 17.608-17.608 17.608C16.883 44.216 9 36.333 9 26.608 9 16.883 16.883 9 26.608 9Z"
            fill="#f5ff00"
          />
        </g>
      </g>
      <g transform="translate(.002 -.001)" filter="url(#b)">
        <path
          data-name="Path 4010"
          d="M34.268 19.685c-.346-.346-3.742 2.425-7.622 6.236-3.95-3.811-7.276-6.583-7.691-6.236-.346.416 2.425 3.742 6.236 7.691-3.811 3.88-6.583 7.276-6.236 7.622.416.346 3.742-2.356 7.691-6.236 3.88 3.88 7.276 6.583 7.622 6.236s-2.356-3.742-6.236-7.622c3.88-3.95 6.583-7.275 6.236-7.691Z"
          fill="#f5ff00"
          fillRule="evenodd"
        />
      </g>
    </svg>
  );
}
